import { useCallback, useEffect, useMemo, useState } from 'react';
export function useCheckboxDependencies(elements, filter, prefix) {
  const [extendedElements, setExtendedElements] = useState(elements.map(extendElement(prefix)));

  // keep the extended elements up to date
  useEffect(() => {
    setExtendedElements(prev => {
      const updated = elements.map(extendElement(prefix));
      return updated.map(e => ({
        ...e,
        checked: !!prev.find(p => p.element === e.element)?.checked
      }));
    });
  }, [elements, prefix]);
  const [searchTerm, setSearchTerm] = useState('');
  const filteredElements = useMemo(() => extendedElements.filter(e => filter(searchTerm, e.element)), [extendedElements, filter, searchTerm]);
  const handleCheckboxListChange = useCallback((element, checked) => prev => {
    const elements = [...prev];
    const index = elements.findIndex(e => e.element === element);
    if (index === -1) {
      return prev;
    }
    elements[index].checked = checked;
    return elements;
  }, []);
  const handleChange = useCallback((element, checked) => {
    setExtendedElements(handleCheckboxListChange(element, checked));
  }, [handleCheckboxListChange]);
  return useMemo(() => ({
    searchTerm,
    setSearchTerm,
    allElements: extendedElements,
    filteredElements,
    handleChange
  }), [extendedElements, filteredElements, handleChange, searchTerm]);
}
function extendElement(prefix) {
  return (element, id) => {
    return {
      checked: false,
      element,
      id: `${prefix}-${id}`
    };
  };
}